import { decamelizeKeys } from "humps";
import { getAuthenticatedData } from "./authenticationService";
import { authenticateWithRefreshToken } from "..";
import { logger } from "@creditas/home-mf-shared";
import { ROOT_LOG_PREFIX } from "../../utils/consts";

const EMBER_AUTH_SESSION = "ember_simple_auth-session";
const AUTH_SESSION = "authSession";

export const setUserTokenByRefreshToken = async (
  refreshToken = ""
): Promise<void> => {
  try {
    if (!refreshToken) throw Error("Refresh token was not found");
    const getNewUserTokenByRefreshTokenResponse =
      await authenticateWithRefreshToken(refreshToken);
    const { accessToken, legacyAccessToken } =
      getNewUserTokenByRefreshTokenResponse;
    const newRefreshToken = getNewUserTokenByRefreshTokenResponse.refreshToken;

    const authenticatedData = getAuthenticatedData();

    if (newRefreshToken && legacyAccessToken) {
      localStorage.setItem(
        EMBER_AUTH_SESSION,
        JSON.stringify(
          decamelizeKeys({
            authenticated: {
              ...authenticatedData,
              accessToken: legacyAccessToken,
              refreshToken: newRefreshToken,
            },
          })
        )
      );
    }

    if (newRefreshToken && accessToken) {
      localStorage.setItem(
        AUTH_SESSION,
        JSON.stringify(
          decamelizeKeys({
            accessToken,
            refreshToken: newRefreshToken,
          })
        )
      );
    }
    logger.info({
      message: `[${ROOT_LOG_PREFIX}][REFRESH_TOKEN] Refresh token finished for ${refreshToken}`,
    });
  } catch (e) {
    logger.error({
      message: `[${ROOT_LOG_PREFIX}][REFRESH_TOKEN] Refresh token failed for ${refreshToken}`,
      error: e,
    });
    throw Error(e);
  }
};
